module.exports = __webpack_public_path__ + "static/media/plain-dagger.0509dd2c.svg";